import { Component, OnInit, Input } from '@angular/core'

@Component({
  selector: 'dmmp-mobile',
  templateUrl: './mobile.component.html'
})
export class MobileComponent implements OnInit {

  @Input() startDate
  @Input() endDate
  @Input() localization
  @Input() items

  constructor() {
    this.items = []
  }

  ngOnInit(): void {
  }

}
